import React from 'react'
import styled from 'styled-components'
import { CropItem, PdfRender } from '../api/utils/types'
import { formatGridLabel } from './utils/formatGridLabel'

export function Ruler({
    style,
    headerPx,
    heightIn,
    pdfRender,
    cropItem,
    pickerUnit,
    leftLabelIsDepth
}: {
    style?: React.CSSProperties
    heightIn?: number
    headerPx: number
    pdfRender: PdfRender
    cropItem: CropItem
    pickerUnit: string
    leftLabelIsDepth: boolean
}) {
    const plus = 1
    const rules = Array(heightIn + plus).fill(null)
    const subRules = Array(4).fill(null)


    const [firstRangeSpan, secondRangeSpan] =
        pdfRender.rangeDepth.active == false
            ? [pdfRender.rangeTime, pdfRender.rangeDepth]
            : pdfRender.rangeTime.active == false
            ? [pdfRender.rangeDepth, pdfRender.rangeTime]
            : leftLabelIsDepth
            ? [pdfRender.rangeDepth, pdfRender.rangeTime]
            : [pdfRender.rangeTime, pdfRender.rangeDepth]


    return (
        <RulerDiv style={{ ...style, marginTop: headerPx, height: `${heightIn + plus}in` }}>
            {rules.map((_, i) => {
                return (
                    <RulerValuesDiv
                        key={`rule-${i}`}
                        style={{
                            marginTop: `${i}in`
                        }}
                    >
                        <label
                            className="label-left"
                            style={{
                                lineHeight: `${1 / (subRules.length + 1)}in`
                            }}
                        >
                            {formatGridLabel(firstRangeSpan, cropItem, i, pickerUnit).map(label => (
                                <>
                                    {label}
                                    <br />
                                </>
                            ))}
                        </label>
                        {secondRangeSpan.active ? (
                            <label
                                className="label-right"
                                style={{
                                    lineHeight: `${1 / (subRules.length + 1)}in`
                                }}
                            >
                                {formatGridLabel(secondRangeSpan, cropItem, i, pickerUnit).map(label => (
                                    <>
                                        {label}
                                        <br />
                                    </>
                                ))}
                            </label>
                        ) : null}

                        {i + 1 == rules.length
                            ? null
                            : subRules.map((_, j) => {
                                  return (
                                      <SubRulerValuesDiv
                                          key={`rule-${i}-${j}`}
                                          style={{
                                              marginTop: `${(j + 1) / (subRules.length + 1)}in`
                                          }}
                                      />
                                  )
                              })}
                    </RulerValuesDiv>
                )
            })}
        </RulerDiv>
    )
}

export const RulerValuesDiv = styled.div`
    height: 1in;
    width: calc(100% - 18px);

    right: -10;
    position: absolute;
    border-top: solid 2px var(--gray-300);
    border-left: solid 1px var(--gray-300);
    border-right: solid 1px var(--gray-300);
    display: inline-flex;
    flex-wrap: nowrap;
    justify-content: space-between;

    label {
        position: relative;
        text-align: left;
        padding-left: 4px;
        padding-right: 2px;
        font-size: 10px;
        font-weight: bold;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        display: inline;
    }
    &:last-child {
        border-left: none;
    }
`

export const SubRulerValuesDiv = styled.div`
    height: 1px;
    width: 100%;
    right: 0;
    position: absolute;
    border-bottom: solid 1px var(--gray-300);
    display: inline;
`
export const RulerDiv = styled.div`
    width: 100%;
    padding: 0;
    height: 100%;
    z-index: 999;
    opacity: 0.8;
    right: -10px;
    position: absolute;
`
